import { action, observable, makeAutoObservable } from 'mobx';
import { FormInputState } from 'src_common/common/mobx-utils/Form2/FormInputState';

export class CasinoGamesSelectState {
    @observable public isOpen: boolean = false;

    public constructor(
        private readonly stateValue: FormInputState<string | string, string>,
        private readonly onChangeCB?: (value: string) => void
    ) {
        makeAutoObservable(this);
    }

    @action public onChange = (event: React.ChangeEvent<HTMLSelectElement>): void => {
        const value = event.target.value;

        if (this.onChangeCB !== undefined) {
            this.onChangeCB(value);
        }

        this.stateValue.setValue(value);
        this.isOpen = !this.isOpen;
    };
}
